import { useEffect, useState } from "react";
import GameioExclusive from "./Home/GameioExclusive";
import ProfileCard from "./Home/ProfileCard";
import Slider from "./Home/Slider";

function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // ⏱ loader time (2 seconds)

    return () => clearTimeout(timer);
  }, []);

  /* =========================
     LOADER SCREEN
  ========================= */
  if (loading) {
    return (
      <div className="fixed inset-0 bg-[#0b0b1d] flex items-center justify-center z-[9999]">
        <img
          src="/assets/newghana.png"
          alt="Loading..."
          className="h-24w-24 animate-pulse"
        />
      </div>
    );
  }

  /* =========================
     HOME PAGE CONTENT
     (IMPORTANT: .home-page wrapper)
  ========================= */
  return (
    <div className="home-page">
      <Slider />
      <ProfileCard />
      <GameioExclusive />
    </div>
  );
}

export default Home;
